import InputMask from 'react-input-mask'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { Controller, useFieldArray,  useFormContext, useWatch } from 'react-hook-form'
import { colourStyles } from '../../../../Utils/styled-components/react-select.style'
import { PERSONA_CEDULA } from '../../../../Utils/url.api'
import { getRequest } from '../../../../Services/axios.service'
import { TerritoryProvider } from '../../Context/territoryContext'
import useTerritory from '../../Context/hook/useTerritory'
import { GeneratorServiceProvider, GeneratorServiceProviderDatatable } from '../../Components/GeneratorServiceProvider'
import MaterialModal from "@mui/material/Modal";
import { Box } from '@mui/material'
import { CONTRIBUTORS } from '../../Utils/contributors-url'
import { boxStyle } from '../../Utils/modal-box'
import ReactTooltip from "react-tooltip";
import { AiOutlineQuestionCircle } from "react-icons/ai";

export const Representatives = ({ documentTypes, phoneTypes }) => {
    const { control, formState: { errors }, watch, register, setValue, getValues, unregister } = useFormContext()
    const { append, update, remove } = useFieldArray({
        control,
        name: 'generadorPrestadorServicios',
        rules: {
            required: { message: 'Debe agregar al menos un proveedor', value: true }
        },
    })

    const watchDocument = useWatch({control, name: 'generatorRepresentative.0.numeroDocumento'})
    const watchDocumentId = useWatch({control, name: 'generatorRepresentative.0.documentTypeId'})

    useEffect(() => {
        if(watchDocumentId !== 3) {
            setValue('generatorRepresentative.0.nombre', null) 
        }
    }, [watchDocument])

    useEffect(() => {
        setValue('generatorRepresentative.0.nombre', null) 
        setValue('generatorRepresentative.0.numeroDocumento', null) 
    }, [watchDocumentId])

    useEffect(() => {
        if(watch('generatorRepresentative.0.telefonoGeneradorRepresentantes.1.phoneTypeId')) {
            setInputConfig((cur) => ({...cur, secondPhone: true}))
            register("generatorRepresentative.0.telefonoGeneradorRepresentantes.1.phoneTypeId", { required: true });
            register("generatorRepresentative.0.telefonoGeneradorRepresentantes.1.numeroTelefono", { required: true });
        } else {
            setInputConfig((cur) => ({...cur, secondPhone: false}))
            unregister(['generatorRepresentative.0.telefonoGeneradorRepresentantes.1'])
        }
    }, [watch('generatorRepresentative.0.telefonoGeneradorRepresentantes.1.phoneTypeId')])

    const [open, setOpen] = useState(false)
    const [selectedProvider, setSelectedProvider] = useState({ state: null, index: null })
    const [inputConfig, setInputConfig] = useState(
        { documentMask: '999-9999999-9', documentError: '', secondPhone: false }
    )
    const [loadingSet, setLoadingSet] = useState(
        { documentNumber: false }
    )

    const validateDocumentNumber = async (value) => {
        const document = value.replace(/-/g, "")
        const documentTypeId = getValues("generatorRepresentative.0.documentTypeId")
        const identificator = documentTypes.find(d => d.id === documentTypeId)?.identificador
        if (identificator === '1' && document.length >= 11) {
            setLoadingSet(cur => ({ ...cur, documentNumber: true }))
            const response = await getRequest(PERSONA_CEDULA(document))
            setLoadingSet(cur => ({ ...cur, documentNumber: false }))
            const { statusCode, data } = response.data
            if (statusCode == 200 && data) {
                setValue("generatorRepresentative.0.nombre", 
                    data.fullName.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), { shouldValidate: true });
                return true
            }
            else if (statusCode == 200 && !data) {
                setInputConfig(curr => ({ ...curr, documentError: "Cédula no valida" }))
                return false
            }
            else {
                setInputConfig(curr => ({ ...curr, documentError: 'No se pudo validar la cédula' }))
                return false
            }
        }
        if (identificator === '2') {
            setLoadingSet(cur => ({ ...cur, documentNumber: true }))
            const { data } = await getRequest(CONTRIBUTORS(document), { baseURL: process.env.REACT_APP_OGTIC_CONTRIBUTORS })
            setLoadingSet(cur => ({ ...cur, documentNumber: false }))

            if (data.valid) {
                setValue("generatorRepresentative.0.nombre", 
                    data.data.name, { shouldValidate: true });
                return true
            }
            else {
                setInputConfig(curr => ({ ...curr, documentError: "RNC no valida" }))
                return false
            }
        }
        return true
    }

    const addServiceProvider = () => {
        setSelectedProvider((cur) => ({ state: null, index: null }))
        setOpen((cur) => true)
    }

    const editServiceProvider = (index) => {
        const spValue = { ...getValues("generadorPrestadorServicios")[index] }
        setSelectedProvider((cur) => ({ state: spValue, index: index }))
        setOpen((cur) => true)
    }

    const onAddServiceProvider = (value) => {
        append(value)
    }

    const onEditServiceProvider = (value, index) => {
        update(index, value)
    }

    const deleteServiceProvider = (index) => {
        remove(index)
    }

    const closeModal = () => {
        setSelectedProvider((cur) => ({ state: null, index: null }))
        setOpen((cur) => false)
    }

    return (
        <section className="text-left my-4">
            <div className='custom-form grid grid grid-cols-1 phone:grid-cols-4 tab-port:grid-cols-[repeat(8,1fr)] gap-x-8'>
                <div className="col-span-full my-6">
                    <h3 className="col-span-full text-2xl text-font-primary">
                        Representante Legal
                        <span className="text-font-muted text-lg">{' (persona autorizada para gestionar los procesos de la solicitud)'}</span>
                    </h3>
                </div>
                <input type="hidden" {...register('generatorRepresentative.0.id',
                    { required: { message: 'Este campo es requerido', value: true }, value: 0 }
                )} />
                
              
                <div className="custom-form__control col-span-2">
                    <label className='custom-form__label'>
                        Tipo de Identificación
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="generatorRepresentative.0.documentTypeId"
                        rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un tipo"
                                getOptionLabel={(option) => option?.description}
                                getOptionValue={(option) => option?.id}
                                options={documentTypes}
                                onChange={(newValue) => {
                                    setValue('generatorRepresentative.0.nombre', null) 
                                    setValue('generatorRepresentative.0.numeroDocumento', null) 
                                    onChange(newValue?.id)
                                }}
                                value={documentTypes?.find(c => c?.id === value)}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.generatorRepresentative?.[0].documentTypeId?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].documentTypeId?.message}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-2">
                    <label className='custom-form__label' htmlFor='numeroDocumento'>
                        Identificación
                        <span className="text-danger"> *</span>
                    </label>
                    <div className="flex gap-x-2 items-center justify-between">
                        <Controller
                            control={control}
                            name="generatorRepresentative.0.numeroDocumento"
                            rules={{
                                required: { message: 'Este campo es requerido', value: true },
                                validate: {
                                    valid: async (val) => await validateDocumentNumber(val)
                                }
                            }}
                            render={({
                                field: { onChange, name, value, ref, onBlur },
                            }) => (
                                <InputMask
                                    id="numeroDocumento"
                                    className='custom-form__input w-full'
                                    onChange={(event) => {
                                        if(watchDocumentId !== 3) {
                                            setValue('generatorRepresentative.0.nombre', null) 
                                        }
                                        onChange(event.target.value)
                                    }}
                                    onBlur={onBlur}
                                    inputRef={ref}
                                    mask={watch("generatorRepresentative.0.documentTypeId") === 1 ? '999-9999999-9' : ''}
                                    maskChar={null}
                                    value={value ?? ""}
                                    disabled={!watch("generatorRepresentative.0.documentTypeId")}
                                />
                            )}>
                        </Controller>
                        {loadingSet.documentNumber && <div className="spinner-loading"></div>}
                    </div>
                    <span>
                        {errors.generatorRepresentative?.[0]?.numeroDocumento?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].numeroDocumento?.message}</p>}
                        {errors.generatorRepresentative?.[0]?.numeroDocumento?.type === 'valid' &&
                            <p className='text-danger' role="alert">{inputConfig?.documentError}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-2 tab-port:col-span-4">
                    <label className='custom-form__label' htmlFor="generatorRepresentative.0.nombre">
                        Nombre Completo
                        <span className="text-danger"> *</span>

                    </label>
                    <input className='custom-form__input' id="generatorRepresentative.0.nombre" type="text"
                        disabled={watch('generatorRepresentative.0.documentTypeId') !== 3}
                        {...register('generatorRepresentative.0.nombre',
                            { required: { message: 'Este campo es requerido', value: true } }
                        )} />
                    <span>
                        {errors.generatorRepresentative?.nombre?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].nombre?.message}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-2">
                    <label className='custom-form__label'>
                        Tipo Teléfono
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="generatorRepresentative.0.telefonoGeneradorRepresentantes.0.phoneTypeId"
                        rules={{
                            required: { value: true, message: 'Este campo es requerido' }
                        }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un tipo"
                                getOptionLabel={(option) => option?.description}
                                getOptionValue={(option) => option?.id}
                                options={phoneTypes}
                                onChange={(newValue) => onChange(newValue?.id)}
                                value={phoneTypes?.find(c => c?.id === value) ?? null}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentante?.[0]?.phoneTypeId?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentante?.[0]?.phoneTypeId.message}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-2">
                    <label className='custom-form__label'>
                        Teléfono
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="generatorRepresentative.0.telefonoGeneradorRepresentantes.0.numeroTelefono"
                        rules={{
                            required: { message: 'Este campo es requerido', value: true },
                        }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <InputMask
                                className='custom-form__input'
                                onChange={onChange}
                                onBlur={onBlur}
                                inputRef={ref}
                                mask={'(999)-999-9999'}
                                maskChar={null}
                                value={value ?? ""}
                                disabled={!watch("generatorRepresentative.0.telefonoGeneradorRepresentantes.0.phoneTypeId")}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentantes?.[0]?.numeroTelefono?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentantes?.[0]?.numeroTelefono?.message}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-2">
                    <label className='custom-form__label'>
                        Tipo Teléfono Secundario
                    </label>
                    <Controller
                        control={control}
                        name="generatorRepresentative.0.telefonoGeneradorRepresentantes.1.phoneTypeId"
                        rules={{
                            required: { value: inputConfig.secondPhone, message: 'Este campo es requerido' },
                            deps: ['generatorRepresentative.0.telefonoGeneradorRepresentantes.1.numeroTelefono']
                        }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un tipo"
                                getOptionLabel={(option) => option?.description}
                                getOptionValue={(option) => option?.id}
                                options={phoneTypes}
                                onChange={(newValue) => onChange(newValue?.id)}
                                value={phoneTypes?.find(c => c?.id === value) ?? null} 
                                isClearable={true}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentante?.[1]?.phoneTypeId?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentante?.[1]?.phoneTypeId.message}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-2 ">
                    <label className='custom-form__label'>
                        Teléfono Secundario
                    </label>
                    <Controller
                        control={control}
                        name="generatorRepresentative.0.telefonoGeneradorRepresentantes.1.numeroTelefono"
                        rules={{
                            required: { message: 'Este campo es requerido', value: inputConfig.secondPhone },
                        }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <InputMask
                                className='custom-form__input'
                                onChange={onChange}
                                onBlur={onBlur}
                                inputRef={ref}
                                mask={'(999)-999-9999'}
                                maskChar={null}
                                value={value ?? ""}
                                disabled={!watch("generatorRepresentative.0.telefonoGeneradorRepresentantes.1.phoneTypeId")}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentantes?.[1]?.numeroTelefono?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0]?.telefonoGeneradorRepresentantes?.[1]?.numeroTelefono?.message}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-2 tab-port:col-span-4" >
                    <label className='custom-form__label' htmlFor='generatorRepresentative.0.correo'>
                        Correo Electrónico
                        <span className="text-danger"> *</span>
                         <AiOutlineQuestionCircle
                    className="inline ml-1"
                    fontSize={"1.5rem"}
                    fontWeight={500}
                    data-tip="Este correo sera utilizado para enviar las<br> informaciones correspondientes al proceso de su solicitud"
                  ></AiOutlineQuestionCircle>
                    </label>
                     <ReactTooltip multiline={true} type="info" effect="solid"/>
                    <input className='custom-form__input' id="generatorRepresentative.0.correo" type="email"
                        {...register('generatorRepresentative.0.correo',
                            {
                                required: { message: 'Este campo es requerido', value: true },
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Correo invalido',
                                }
                            })} />
                    <span>
                        {errors.generatorRepresentative?.[0]?.correo?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].correo?.message}</p>}
                        {errors.generatorRepresentative?.[0]?.correo?.type === 'pattern' && <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0]?.correo?.message}</p>}
                    </span>
                    
                </div>
               
               
                <div className="custom-form__control col-span-2 tab-port:col-span-4">
                    <label className='custom-form__label' htmlFor='generatorRepresentative.0.nacionalidad'>
                        Nacionalidad
                    </label>
                    <input className='custom-form__input' id="generatorRepresentative.0.nacionalidad" type="text"
                        {...register('generatorRepresentative.0.nacionalidad')} />
                </div>
                <div className="custom-form__control col-span-full">
                    <label className='custom-form__label' htmlFor="generatorRepresentative.0.direccion">
                        Domicilio
                        <span className="text-danger"> *</span>
                    </label>
                    <textarea className="custom-form__input" id="generatorRepresentative.0.direccion" cols="30" rows="3"
                        {...register('generatorRepresentative.0.direccion',
                            {
                                required: { message: 'Este campo es requerido', value: true }
                            })} />
                    <span>
                        {errors.generatorRepresentative?.[0]?.direccion?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].direccion?.message}</p>}
                    </span>
                </div>

                <TerritoryProvider>
                    <RepresentativeAddress />
                </TerritoryProvider>

                <div className="col-span-full my-6">
                    <h3 className="col-span-full text-2xl text-font-primary">
                        Prestador de Servicio
                        <span className="text-font-muted text-lg">{' (Persona física o jurídica autorizada para brindar el servicio de manejo de residuos)'}</span>
                    </h3>
                </div>

                <div className="col-span-full my-4">
                    <button
                        type="button"
                        onClick={() => addServiceProvider()}
                        className="py-4 px-32 text-2xl bg-[#003670] text-white rounded-lg"
                    >
                        Agregar nuevo prestador de servicio
                    </button>
                </div>

                <MaterialModal
                    open={open}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    sx={{overflow: 'hidden'}}
                >
                    <Box sx={boxStyle}>
                        <div className="sticky top-0 flex justify-between text-2xl text-font-dark font-medium py-6 px-8 border-b border-t border-bd-light bg-white z-30">
                            <h2>Prestador de Servicio</h2>
                            <button className="font-danger"
                                onClick={() => closeModal()}>&times;</button>
                        </div>
                        <div className="my-8 px-2">
                            <TerritoryProvider>
                                <GeneratorServiceProvider
                                    onClose={closeModal}
                                    onAdd={onAddServiceProvider}
                                    onEdit={onEditServiceProvider}
                                    documentTypes={documentTypes}
                                    phoneTypes={phoneTypes}
                                    patchValue={selectedProvider} />
                            </TerritoryProvider>
                        </div>
                    </Box>
                </MaterialModal>

                <div className="col-span-full">
                    <GeneratorServiceProviderDatatable
                        rows={watch("generadorPrestadorServicios")?.map((x, i) => ({ ...x, _id: i }))}
                        onDelete={deleteServiceProvider}
                        onEdit={editServiceProvider} />
                    <span className='text-xl'>
                        {errors.generadorPrestadorServicios?.root?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.generadorPrestadorServicios?.root?.message}</p>}
                    </span>
                </div>
            </div>
        </section>
    )
}

const RepresentativeAddress = () => {
    const { control, formState: { errors }, watch, register, setValue, getValues } = useFormContext()

    const { fetchDistricts, fetchMunicipalities, fetchProvinces, loadingSet, territories } = useTerritory()

    const watchProvince = useWatch({ control, name: 'generatorRepresentative.0.provincia' })
    const watchMunicipality = useWatch({ control, name: 'generatorRepresentative.0.municipio' })

    useEffect(() => {
        fetchProvinces()
    }, [])

    useEffect(() => {
        if (watchProvince) fetchMunicipalities(watchProvince)
        if (watchMunicipality && watchProvince) fetchDistricts(watchMunicipality, watchProvince)

    }, [watchMunicipality, watchProvince])

    return (
        <>
            <div className="custom-form__control col-span-2">
                <label className='custom-form__label'>
                    Provincia
                    <span className="text-danger"> *</span>
                </label>
                <Controller
                    control={control}
                    name="generatorRepresentative.0.provincia"
                    rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                    render={({
                        field: { onChange, name, value, ref, onBlur },
                    }) => (
                        <Select
                            ref={ref}
                            onBlur={onBlur}
                            styles={colourStyles}
                            noOptionsMessage={() => "Sin datos"}
                            placeholder="Seleccione una provincia"
                            isLoading={loadingSet.provinces}
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.code}
                            options={territories.provinces}
                            onChange={(newValue) => {
                                onChange(newValue?.code)
                                setValue("generatorRepresentative.0.municipio", null)
                                setValue("generatorRepresentative.0.ciudad", null)
                            }}
                            value={territories.provinces?.find(c => c?.code === value) ?? null}
                        />
                    )}>
                </Controller>
                <span>
                    {errors.generatorRepresentative?.[0]?.provincia?.type === 'required' &&
                        <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].provincia?.message}</p>}
                </span>
            </div>

            <div className="custom-form__control col-span-2">
                <label className='custom-form__label'>
                    Municipio
                    <span className="text-danger"> *</span>
                </label>
                <Controller
                    control={control}
                    name="generatorRepresentative.0.municipio"
                    rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                    render={({
                        field: { onChange, name, value, ref, onBlur },
                    }) => (
                        <Select
                            ref={ref}
                            onBlur={onBlur}
                            styles={colourStyles}
                            noOptionsMessage={() => "Sin datos"}
                            placeholder="Seleccione un municipio"
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.code}
                            options={territories.municipalities}
                            isLoading={loadingSet.municipalities}
                            onChange={(newValue) => {
                                onChange(newValue?.code)
                                setValue("generatorRepresentative.0.ciudad", null)
                            }}
                            value={territories.municipalities?.find(c => c?.code === value) ?? null}
                        />
                    )}>
                </Controller>
                <span>
                    {errors.generatorRepresentative?.[0]?.municipio?.type === 'required' &&
                        <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].municipio?.message}</p>}
                </span>
            </div>

            <div className="custom-form__control col-span-2">
                <label className='custom-form__label'>
                    Ciudad o Sección
                    <span className="text-danger"> *</span>
                </label>
                <Controller
                    control={control}
                    name="generatorRepresentative.0.ciudad"
                    rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                    render={({
                        field: { onChange, name, value, ref, onBlur },
                    }) => (
                        <Select
                            ref={ref}
                            onBlur={onBlur}
                            styles={colourStyles}
                            noOptionsMessage={() => "Sin datos"}
                            placeholder="Seleccione un ciudad"
                            isLoading={loadingSet.districts}
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.code}
                            options={territories.districts}
                            onChange={(newValue) => {
                                onChange(newValue?.code)
                            }}
                            value={territories.districts?.find(c => c?.code === value) ?? null}
                        />
                    )}>
                </Controller>
                <span>
                    {errors.generatorRepresentative?.[0]?.ciudad?.type === 'required' &&
                        <p className='text-danger' role="alert">{errors.generatorRepresentative?.[0].ciudad?.message}</p>}
                </span>
            </div>

            <div className="custom-form__control col-span-2">
                <label className='custom-form__label' htmlFor="generatorRepresentative.0.paraje">
                    Paraje
                </label>
                <input className='custom-form__input' id="generatorRepresentative.0.paraje" type="text"
                    {...register('generatorRepresentative.0.paraje')} />
            </div>
        </>
    )
}

